import { observer } from 'mobx-react';
import React, { CSSProperties } from 'react';
import { Card } from '@monorepo/base/src/components/card/card';
import { Input } from '@monorepo/base/src/components/form/input/input';
import { DataAttribute } from '@monorepo/tools/src/lib/models/data-attr.model';
import { Spacer } from '@monorepo/base/src/components/spacer/spacer';
import { ButtonGroup, GButton } from '@monorepo/base/src/components/buttons/group/button-group';
import { Distribution, Distributions } from '../../../../enums/distribution';
import { CampaignPhaseModel } from '../../../../models/campaign.model';

interface Props {
	currentPhase?: CampaignPhaseModel;
	style?: CSSProperties;
}

export const Budget = observer(({ currentPhase, style }: Props) => {
	return (
		<Card
			id={'dailyBudget'}
			title={'Daily Budget'}
			icon={'currency-dollar-circle'}
			style={style}
			debugProps={{ dataAttrs: [new DataAttribute('id', 'daily_budget_section')] }}>
			<Spacer />
			<ButtonGroup
				defaultValue={currentPhase?.daily_budget?.distribution}
				title={'Distribution'}
				onChange={(setValues: Set<string>) =>
					currentPhase?.daily_budget?.setDistribution(setValues.values().next().value as Distribution)
				}>
				<GButton
					icon={'directions-run'}
					text={Distributions.Eager}
					value={Distributions.Eager}
					debugProps={{ dataAttrs: [new DataAttribute('id', 'distribution_eager')] }}
				/>
				<GButton
					icon={'scales-02'}
					text={Distributions.Evenly}
					value={Distributions.Evenly}
					debugProps={{ dataAttrs: [new DataAttribute('id', 'distribution_evenly')] }}
				/>
			</ButtonGroup>

			<Input
				type="number"
				icon="currency-dollar"
				value={currentPhase?.daily_budget?.limit?.toString() || ''}
				placeholder="Daily Budget Limit"
				onValue={limit => currentPhase?.daily_budget?.setLimit(Number(limit))}
				debugProps={{ dataAttrs: [new DataAttribute('id', 'daily_budget_limit')] }}
			/>
		</Card>
	);
});
